import React from "react";

import { ReactComponent as NotFound } from "../../assets/icons/404.svg";
import "./NotFoundScreen.scss";
import { useNavigate } from "react-router-dom";

const NotFoundScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="notFoundContainer">
      <NotFound />
      <p>We seem to have run into a bit of a problem with this page.</p>
      <button
        onClick={() => navigate("/")}
      >
        Back to Home
      </button>
    </div>
  );
};

export default NotFoundScreen;